/* eslint-disable global-require */
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { WagmiProvider } from 'configs/web3.config';
import { Provider } from 'react-redux';
import store from 'store';
import Router from './routes';

window.Buffer = window.Buffer || require('buffer').Buffer;

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <WagmiProvider>
          <Router />
        </WagmiProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
